var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jf-toggler"},[_c('div',{staticClass:"switch-toggle",class:{'left': _vm.value, 'right': !_vm.value},on:{"click":function($event){return _vm.toggleSelection()}}},[_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }